let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Mvpe")).then(() => parcelRequire('70m7S'));